import TAlert from './alert.vue'

TAlert.install = Vue => {
  Vue.component(TAlert.name, TAlert)
}

export {
  TAlert
}



// WEBPACK FOOTER //
// ./src/module/alert/index.js